<template>
  <c-form-builder-modal-base
    ref="form"
    v-bind="{ ...$attrs, ...passThroughProps }"
    :value="modelValue"
    @input="handleInput"
    @submit="$emit('submit', $event)"
    @invalid-submit="$emit('invalid-submit', $event)"
    @close="$emit('close', $event)"
    @open="$emit('open', $event)"
    @edit="$emit('edit', $event)"
    @file:add="$emit('file:add', $event)"
    @file:remove="$emit('file:remove', $event)"
    @field:action="$emit('field:action', $event)"
    @field-pre-validate="$emit('field-pre-validate', $event)"
  >
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps || {}" />
    </template>
  </c-form-builder-modal-base>
</template>

<script>
import CFormBuilderModalBase from './index.vue'

const baseComponent = CFormBuilderModalBase?.default || CFormBuilderModalBase
const baseProps = baseComponent?.props
  || baseComponent?.options?.props
  || {}
const { value: _value, ...CFormBuilderModalBaseProps } = baseProps

export default {
  name: 'CFormBuilderModal',

  components: {
    CFormBuilderModalBase
  },

  inheritAttrs: false,

  props: {
    ...CFormBuilderModalBaseProps,
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },

  emits: [
    'update:modelValue',
    'input',
    'submit',
    'invalid-submit',
    'close',
    'open',
    'edit',
    'file:add',
    'file:remove',
    'field:action',
    'field-pre-validate'
  ],

  computed: {
    passThroughProps () {
      const { modelValue, ...rest } = this.$props
      return rest
    }
  },

  methods: {
    handleInput (value) {
      this.$emit('update:modelValue', value)
      this.$emit('input', value)
    },

    forceInput (...args) {
      return this.$refs.form?.forceInput(...args)
    },

    resetValidations (...args) {
      return this.$refs.form?.resetValidations(...args)
    }
  }
}
</script>
